import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities, onActivityClick }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'new_follower':
        return { name: 'UserPlus', color: 'text-green-500' };
      case 'project_completed':
        return { name: 'CheckCircle2', color: 'text-blue-500' };
      case 'profile_updated':
        return { name: 'Edit', color: 'text-purple-500' };
      default:
        return { name: 'Activity', color: 'text-gray-500' };
    }
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    return 'Just now';
  };

  if (!activities || activities?.length === 0) {
    return (
      <div className="modern-card text-center py-8">
        <Icon name="Activity" size={48} className="text-muted-foreground/30 mx-auto mb-3" />
        <p className="text-muted-foreground">No recent activity</p>
      </div>
    );
  }

  return (
    <div className="modern-card max-h-[800px] overflow-y-auto">
      <div className="space-y-3">
        {activities?.map((activity) => {
          const iconData = getActivityIcon(activity?.type);
          
          return (
            <div
              key={activity?.id}
              onClick={() => onActivityClick?.(activity?.actorId)}
              className="flex items-start gap-3 p-3 rounded-lg hover:bg-background/50 transition-colors cursor-pointer group"
            >
              {/* Activity Icon */}
              <div className={`w-10 h-10 rounded-full bg-background flex items-center justify-center flex-shrink-0 ${iconData?.color}`}>
                <Icon name={iconData?.name} size={18} />
              </div>

              {/* Activity Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <div className="flex items-center gap-2 min-w-0">
                    {activity?.actorHeadshot ? (
                      <img
                        src={activity?.actorHeadshot}
                        alt={activity?.actorName}
                        className="w-6 h-6 rounded-full object-cover border border-border"
                      />
                    ) : (
                      <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center">
                        <Icon name="Mic" size={12} className="text-white" />
                      </div>
                    )}
                    <span className="text-sm font-semibold text-card-foreground truncate group-hover:text-purple-400 transition-colors">
                      {activity?.actorName}
                    </span>
                  </div>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">
                    {getTimeAgo(activity?.timestamp)}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  {activity?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivityFeed;